import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './FloatingContainer.html?raw';
import topic from 'dojo/topic';
import on from 'dojo/on';


class FloatingContainer extends compose(_WidgetBaseSP) {
    templateString: any = template;

    mainContainer: HTMLElement;

    private sourceTarget: any = null;
    private permanent: boolean = false;
    private fade: boolean = false;
    private scrollEventNode: any = window;
    private additionalCloseEvent: dojo.Handle = null;
    private closeEventHitched: any = null;
    private contentClickHandle: dojo.Handle = null;
    private scrollEvtHandles: Array<dojo.Handle> = null;
    private isShown: boolean = false;
    private destroyOnClose: boolean = false;

    private mutationObserver: MutationObserver;

    setContent(content: HTMLElement | string) {
        if (typeof (content) == "string") {
            this.UiModder.domAttr.set(this.mainContainer, "innerHTML", content);
        } else {
            this.UiModder.domConstruct.place(content, this.mainContainer);
        }
    }
    /**
     * Öffnet den Floatingcontainer in einem alternativen, "einfachen" Modus mit absoluter Positionierung direkt an der aufrufenden Node
     * d.h. via Stylesheets muss die korrekte Positionierung des Containers selber vorgenommen werden.
     * @param config
     */
    openSimple(config: {
        evtSource: MouseEvent | Event | HTMLElement,
        nodeClass?: string,
        content?: string | HTMLElement,
        permanent?: boolean,
        fade?: boolean,
        alternativeTarget?: HTMLElement,
        zIndex?: number,
        destroyOnClose?: boolean
    }): HTMLElement {
        if (!config) return;
        let callingElement: EventTarget = null;


        try {
            if (config.evtSource instanceof HTMLElement) {
                // wenn wir von einem HTMLElement aufgerufen werden:
                callingElement = config.evtSource; // wir sind das Klicktarget
            } else {
                callingElement = config.evtSource.target;

                
                if (config.evtSource.preventDefault) config.evtSource.preventDefault();
                if (config.evtSource.stopPropagation) config.evtSource.stopPropagation();

                //console.debug(this.id + ": source is event", evtSource, callingElement, x, y);
            }
        } catch (ex) {
            console.error(this.id + " open (simple) failed", config.evtSource, ex);
            debugger; // absichtlich drin gelassen. - lg, rj
            config.alternativeTarget = document.body;
        }

        let elem = callingElement;
        if (config.alternativeTarget) elem = config.alternativeTarget;

        if (elem["mcFloatingContainer"] != null) {
            let container: FloatingContainer = elem["mcFloatingContainer"];
            if (container.permanent != true) {
                container.close();
            }
            return;
        }

        topic.publish("/Global/Click", this.id); // damit andere Menüs wieder zugehen!

        if (typeof (config.zIndex) == "number") {
            this.UiModder.domStyle.set(this.domNode, "zIndex", config.zIndex);
        }

        this.sourceTarget = elem;

        this.permanent = config.permanent === true;

        // falls permanent: klick auf den Inhalt darf nicht über Propagation zum Schließen führen!
        if (this.permanent && config.content instanceof HTMLElement) {
            let node = config.content as HTMLElement;
            this.contentClickHandle = on(node, "click", function (evt: MouseEvent) { evt.stopPropagation(); });
        }

        this.UiModder.domClass.add(this.domNode, "simplePosition");
        if (config.nodeClass) this.UiModder.domClass.add(this.domNode, config.nodeClass);
        this.UiModder.domConstruct.place(this.domNode, config.alternativeTarget ? config.alternativeTarget : callingElement as HTMLElement);

        if (config.content) {
            this.setContent(config.content);
        }

        this.fade = config.fade === true;
        this.UiModder.domClass.toggle(this.domNode, "fadeOpacity fast hidden", this.fade);

        if (this.fade) {
            setTimeout(lang.hitch(this, this.UiModder.domClass.toggle, this.domNode, "hidden", false), 20);
        }

        this.UiModder.domStyle.set(this.domNode, "display", "block");
        this.isShown = true;


        return this.domNode;
    }

    /**
 * Unbedingt das Klickevent mitgeben, darauf positioniert sich der Container anschließend.
 * @param evtSource Klickevent oder HTML-Node, die als Ursprung dienen.
 * @param alternativeTarget Alternatives HTML-Element, an dem der Container sich schwebend befestigt.
 * @param permanent Wenn true, bleibt der Container auch bei globalen Klickevents außerhalb offen.
 * @param fade Container wird mit Fade-In und Fade-Out ein- und ausgeblendet
 * @param destroyOnClose Der übergebene Content erhalten werden, wenn der Container geschlossen wird
 */
    open(evtSource: MouseEvent | Event | HTMLElement,
        content?: string | HTMLElement,
        permanent?: boolean,
        fade: boolean = false,
        alternativeTarget?: HTMLElement,
        zIndex?: number,
        destroyOnClose?: boolean) {
        if (!evtSource) return;

        this.destroyOnClose = destroyOnClose;

        let x: number = null;
        let y: number = null;
        let callingElement: EventTarget = null;
        try {
            if (evtSource instanceof HTMLElement) {
                // wenn wir von einem HTMLElement aufgerufen werden:
                callingElement = evtSource; // wir sind das Klicktarget
                x = evtSource.offsetLeft;
                y = evtSource.offsetTop + evtSource.clientHeight; // direkt unterhalb ansetzen

                // bei verschachtelt absolut positionierten Items fängt jedes Element relativ zum vorherigen relative parent an
                // also rauf bis zur Wurzel und auf dem Weg den absoluten offset ermitteln
                let parent = evtSource.offsetParent as HTMLElement;
                while (parent) {
                    if (parent.offsetLeft) x += parent.offsetLeft;
                    if (parent.offsetTop) y += parent.offsetTop;
                    parent = parent.offsetParent as HTMLElement;
                }

                this.UiModder.domConstruct.place(this.domNode, alternativeTarget ? alternativeTarget : callingElement as HTMLElement);

                //console.debug(this.id + ": source is htmlelement", evtSource, x, y);

            } else {
                callingElement = evtSource.target;

                if (!(evtSource instanceof MouseEvent)) {
                    x = (<HTMLElement>callingElement).clientLeft;
                    y = (<HTMLElement>callingElement).clientTop;
                } else {
                    x = evtSource.clientX;
                    y = evtSource.clientY;
                }

                if (evtSource.preventDefault) evtSource.preventDefault();
                if (evtSource.stopPropagation) evtSource.stopPropagation();

                //console.debug(this.id + ": source is event", evtSource, callingElement, x, y);
            }
        } catch (ex) {
            console.error(this.id + " open failed", evtSource, ex);
            debugger; // absichtlich drin gelassen. - lg, rj
            alternativeTarget = document.body;
        }

        let elem = callingElement;
        if (alternativeTarget) elem = alternativeTarget;

        if (elem["mcFloatingContainer"] != null) {
            let container: FloatingContainer = elem["mcFloatingContainer"];
            if (container.permanent != true) {
                container.close();
            }
            return;
        }

        topic.publish("/Global/Click", this.id); // damit andere Menüs wieder zugehen!

        if (typeof (zIndex) == "number") {
            this.UiModder.domStyle.set(this.domNode, "zIndex", zIndex);
        }

        this.sourceTarget = elem;

        this.permanent = permanent === true;

        // falls permanent: klick auf den Inhalt darf nicht über Propagation zum Schließen führen!
        if (this.permanent && content instanceof HTMLElement) {
            let node = content as HTMLElement;
            this.contentClickHandle = on(node, "click", function (evt: MouseEvent) { evt.stopPropagation(); });
        }

        let fixedAncestor = null;
        
        if (alternativeTarget) {

            //fixedAncestor = this.getFixedAncestor(alternativeTarget);
            let rect = alternativeTarget.getBoundingClientRect();
            x = alternativeTarget.offsetLeft;// rect.left;
            y = rect.top + rect.height;//0;// rect.top;

            //console.debug(this.id + ": alternative target is set!", alternativeTarget, rect, x, y);

            this.scrollEventNode = this.getFirstScrollingParent(elem as HTMLElement);



        } else {
            fixedAncestor = this.getFixedAncestor(callingElement as HTMLElement);
            this.scrollEventNode = this.getFirstScrollingParent((callingElement as HTMLElement).parentElement);

        }



        //if (alternativeTarget) {
        //    x = alternativeTarget.offsetLeft;
        //    y = alternativeTarget.offsetTop;
        //} else {

        
        //}


        if (fixedAncestor) {
            let unfixedAncestor: HTMLElement = null;
            this.scrollEventNode = fixedAncestor;
            
            this.additionalCloseEvent = on(fixedAncestor, "click", lang.hitch(this, function (evt) {
                evt.stopPropagation();
                this.close();
            }));

            unfixedAncestor = this.getFirstNonFixedSuccessor(fixedAncestor);
            
            if (unfixedAncestor) {
                x -= unfixedAncestor.offsetLeft;
                y += unfixedAncestor.scrollTop;// + unfixedAncestor.offsetTop;
            }

            //console.debug(this.id + ": fixed and unfixed ancestors", fixedAncestor, unfixedAncestor);

                //this.UiModder.domStyle.set(this.domNode, "zIndex", 99);
                //this.UiModder.domStyle.set(this.domNode, "position", "absolute");
                //this.UiModder.domStyle.set(this.domNode, "inset", 0);
                //this.UiModder.domStyle.set(this.domNode, "top", 0);
                //this.UiModder.domStyle.set(this.domNode, "left", 0);


                //this.UiModder.domStyle.set(alternativeTarget ? alternativeTarget : evt.target as HTMLElement, "position", "relative");
        }

        else {
            if (alternativeTarget) {
                this.UiModder.domClass.add(this.domNode, "fixedOnElement");
            }
        }

        //let scrollingParent = this.getScrollingAncestor(alternativeTarget);
        //this._registerMutationObserversOnParents(this.scrollEventNode);
        this._unregisterScrollEvents();
        this.registerScrollOnNode(this.scrollEventNode);

        elem["mcFloatingContainer"] = this;

        if (content) {
            this.setContent(content);
        }

        this.domNode.style.setProperty('--mouse-x', x + 'px')
        this.domNode.style.setProperty('--mouse-y', y + 'px');


        

        if (fixedAncestor) {
            //this.UiModder.domStyle.set(this.domNode, "zIndex", 99);
            //this.UiModder.domStyle.set(this.domNode, "position", "absolute");
            //this.UiModder.domStyle.set(this.domNode, "top", 0);
            //this.UiModder.domStyle.set(this.domNode, "left", 0);

            //this.UiModder.domConstruct.place(this.domNode, document.body);

        } else {

        }

        this.UiModder.domConstruct.place(this.domNode, alternativeTarget ? alternativeTarget : callingElement as HTMLElement);

        this.fade = fade === true;
        this.UiModder.domClass.toggle(this.domNode, "fadeOpacity fast hidden", this.fade);

        if (this.fade) {
            setTimeout(lang.hitch(this, this.UiModder.domClass.toggle, this.domNode, "hidden", false), 20);
        }
// rechnen ob das Element sich in der Höhe noch ausgeht, zb weil es ganz am unteren Bildrand auftaucht
        // falls nicht, wird es umgekehrt und wächst nach oben


        let maxY = window.innerHeight;
        let maxX = window.innerWidth;

        this.UiModder.domStyle.set(this.domNode, "display", "block");
        this.isShown = true;

        
        // tatsächliche Größe?
        let ownHeight = this.domNode.clientHeight;
        let ownWidth = this.domNode.offsetWidth;

        if (y + ownHeight > maxY) {
            this.UiModder.domClass.add(this.domNode, "verticalUp");
        }

        let boundingClientRect = this.domNode.getBoundingClientRect();

        if (boundingClientRect.x + boundingClientRect.width > maxX) {
            let newX = x - boundingClientRect.width;
            this.domNode.style.setProperty('--mouse-x', newX + 'px')
        }
    }

    private _onObserving(evt) {
        //console.debug("_onObserving", evt);
    }
    private _onObservingMutation(evt) {
        //console.debug("_onObservingMutation", evt);
    }

    close(evt?: MouseEvent) {
        if (!this.isShown || this._destroyed) return;
        try {
            this.UiModder.domClass.toggle(this.domNode, "fadeOpacity fast hidden", false);

            if (this.scrollEvtHandles && this.scrollEvtHandles.length) {
                for (let handle of this.scrollEvtHandles) {
                    handle.remove();
                }

                this.scrollEvtHandles = [];
            }

            if (this.additionalCloseEvent) {
                this.additionalCloseEvent.remove();
                this.additionalCloseEvent = null;
            }

            if (this.contentClickHandle) {
                this.contentClickHandle.remove();
                this.contentClickHandle = null;
            }


            if (this.fade) {
                this.UiModder.domClass.add(this.domNode, "fadeOpacity fast");
                this.UiModder.domClass.add(this.domNode, "hidden");
                this.fade = false;
                setTimeout(lang.hitch(this, this.close), 250); // mich selber nochmal aufrufen, ohne Fade
                return;
            } else {
                this.UiModder.domStyle.set(this.domNode, "display", "");
            }

            this.isShown = false;

            if (this.sourceTarget) {
                this.sourceTarget["mcFloatingContainer"] = null;
                this.sourceTarget = null;
            }

            this.emit("close");

            if (!this.destroyOnClose) {
                setTimeout(lang.hitch(this, this.destroy), 10);
            } else {
                setTimeout(lang.hitch(this, this._unregisterScrollEvents), 10);
                
            }
        } catch (ex) {

        }
    }
    private _unregisterScrollEvents() {
        if (this.scrollEvtHandles && this.scrollEvtHandles.length) {
            for (let handle of this.scrollEvtHandles) {
                handle.remove();
            }

            this.scrollEvtHandles = [];
        }
    }

    setNewContent(content: HTMLElement): void {
        this.UiModder.domConstruct.empty(this.mainContainer);
        this.setContent(content);
    }

    private registerScrollOnNode(elem) {
        if (!elem) return;
        this.initialScrollX = 0;
        this.initialScrollY = 0;
        if (typeof (elem.scrollY) == "number") {
            this.initialScrollY = elem.scrollY;
        } else if (typeof (elem.scrollTop) == "number") {
            this.initialScrollY = elem.scrollTop;
        }
        if (typeof (elem.scrollX) == "number") {
            this.initialScrollX = elem.scrollX;
        } else if (typeof (elem.scrollLeft) == "number") {
            this.initialScrollX = elem.scrollLeft;
        }

        if (typeof (this.initialScrollY) != "number") this.initialScrollY = 0;
        if (typeof (this.initialScrollX) != "number") this.initialScrollX = 0;

        //this._unregisterScrollEvents();
        this.scrollEvtHandles.push(on(elem, "scroll", lang.hitch(this, this._onWindowScroll)));

    }
    private _registerMutationObserversOnParents(elem: HTMLElement) {
        do {
            try {
                this.mutationObserver.observe(elem, { attributes: true, childList: true, characterData: true,attributeFilter:["scrollTop"], subtree: true });
            } catch (ex) {
                console.warn(this.id + ": observing element failed", elem, ex);
            }
        } while (elem = elem.parentElement as HTMLElement);
    }
    private _isScrollable(elem: HTMLElement) {
        return elem.scrollWidth > elem.clientWidth || elem.scrollHeight > elem.clientHeight;
    }
    private getFirstNonFixedSuccessor(fixedElement: HTMLElement): HTMLElement {
        while (getComputedStyle(fixedElement).position == 'fixed') {
            fixedElement = fixedElement.firstElementChild as HTMLElement;

            if (!fixedElement) return null;
        } 

        return fixedElement;
    }
    private getFixedAncestor(elem: HTMLElement): HTMLElement {
        do {
            if (getComputedStyle(elem).position == 'fixed') {
                //console.debug("getFixedAncestor");
                return elem;
            }
        } while (elem = elem.offsetParent as HTMLElement);
        return null;
    }

    private getFirstScrollingParent(elem: HTMLElement): HTMLElement {
        do {
            if (elem && this._isScrollable(elem)) {
                return elem;
            }
        } while (elem = elem.parentElement as HTMLElement);
        return null;
    }

    private scrollEvent: any = null;
    private initialScrollX = 0;
    private initialScrollY = 0;
    protected _setupSubscriptions() {
        super._setupSubscriptions.apply(this, arguments as any);

        this.addSubscription("/Global/Click", lang.hitch(this, this._onGlobalClick));

    }

    private updateScrollY() {
        let scroll = 0;

        try {
            if (typeof (this.scrollEventNode.scrollY) == "number") {
                scroll = this.scrollEventNode.scrollY;
            } else if (typeof (this.scrollEventNode.scrollTop) == "number") {
                scroll = this.scrollEventNode.scrollTop;
            }
            let diff = scroll - this.initialScrollY;

            this.domNode.style.setProperty("--scrollY", diff.toString() + "px");
        } catch (ex) {

        }
    }
    private updateScrollX() {
        let scroll = 0;

        try {
            if (typeof (this.scrollEventNode.scrollX) == "number") {
                scroll = this.scrollEventNode.scrollX;
            } else if (typeof (this.scrollEventNode.scrollLeft) == "number") {
                scroll = this.scrollEventNode.scrollLeft;
            }
            let diff = scroll - this.initialScrollX;

            this.domNode.style.setProperty("--scrollX", diff.toString() + "px");
        } catch (ex) {

        }
    }

    setOffset(x: number = 0, y: number = 0) {
        this.domNode.style.setProperty("--offsetX", x.toString() + "px");
        this.domNode.style.setProperty("--offsetY", y.toString() + "px");
    }

    destroy() {

        this._unregisterScrollEvents();
        super.destroy.apply(this, arguments as any);


    }

    postMixInProperties() {
        super.postMixInProperties.apply(this, arguments as any); // standard code aus basisklasse     
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        ///
        this.isShown = false;
        this.initialScrollX = 0;
        this.initialScrollY = window.scrollY;
        this.scrollEventNode = window;
        this.scrollEvent = lang.hitch(this, this._onWindowScroll);
        this.closeEventHitched = lang.hitch(this, this.close);

        this.scrollEvtHandles = [];

        //this.mutationObserver = new MutationObserver(lang.hitch(this, this._onObservingMutation));
    }

    private _onGlobalClick(sourceId) {
        if (sourceId != this.id && this.permanent != true) {
            this.close();
        }
    }

    private _onWindowScroll(evt) {
        //console.debug("_onWindowScroll", evt);
        this.updateScrollY();
        this.updateScrollX();
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

    }
}

export default mdsWidget(FloatingContainer);
